import { render, staticRenderFns } from "./ServiceCZNConfig.vue?vue&type=template&id=67415adc"
import script from "./ServiceCZNConfig.vue?vue&type=script&lang=js"
export * from "./ServiceCZNConfig.vue?vue&type=script&lang=js"
import style0 from "./ServiceCZNConfig.vue?vue&type=style&index=0&id=67415adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports